var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSystemSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6.5C8.66 6.5 9 6.16 9 5.75C9 5.34 8.66 5 8.25 5C7.84 5 7.5 5.34 7.5 5.75C7.5 6.16 7.84 6.5 8.25 6.5Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.5C8.66 12.5 9 12.16 9 11.75C9 11.34 8.66 11 8.25 11C7.84 11 7.5 11.34 7.5 11.75C7.5 12.16 7.84 12.5 8.25 12.5Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 18.5C8.66 18.5 9 18.16 9 17.75C9 17.34 8.66 17 8.25 17C7.84 17 7.5 17.34 7.5 17.75C7.5 18.16 7.84 18.5 8.25 18.5Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.5V3.5C19.5 3.1 19.34 2.72 19.06 2.44C18.78 2.16 18.4 2 18 2H6C5.6 2 5.22 2.16 4.94 2.44C4.66 2.72 4.5 3.1 4.5 3.5V20C4.5 20.4 4.66 20.78 4.94 21.06C5.22 21.34 5.6 21.5 6 21.5H18V20H6V15.5H12V14H6V9.5H19.5ZM6 3.5H18V8H6V3.5Z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.31V14.2H22.73C22.67 13.87 22.49 13.53 22.31 13.2L23.22 12.36L22.38 11.58L21.47 12.42C21.17 12.25 20.81 12.09 20.38 12.03V10.86H19.17V12.03C18.81 12.09 18.45 12.25 18.08 12.42L17.17 11.58L16.33 12.36L17.24 13.2C17.06 13.48 16.88 13.81 16.82 14.2H15.55V15.31H16.82C16.88 15.64 17.06 15.98 17.24 16.31L16.33 17.15L17.17 17.93L18.08 17.09C18.38 17.26 18.74 17.42 19.17 17.48V18.65H20.38V17.48C20.74 17.42 21.1 17.26 21.47 17.09L22.38 17.93L23.22 17.15L22.31 16.31C22.49 16.03 22.67 15.7 22.73 15.31H24ZM19.78 16.43C18.75 16.43 17.97 15.71 17.97 14.76C17.97 13.81 18.75 13.09 19.78 13.09C20.81 13.09 21.59 13.81 21.59 14.76C21.59 15.71 20.81 16.43 19.78 16.43Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSystemSettings);
export default __webpack_public_path__ + "static/media/ic-system-settings.5ce307832a0e412648a3a2357916c248.svg";
export { ForwardRef as ReactComponent };